import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_TOPIC } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("TopicDAO.getListOptions - input:", input);
  const parentId = input?.parentId;
  if(!parentId) {
    return []
  }
  return getLookupList(ENTITY_NAME_TOPIC, {parentId})
}

export const getAllListOptions = async(input) => {
  console.log("TopicDAO.getAllListOptions - input:", input);
  const parentId = input?.parentId ?? '';
  return getLookupList(ENTITY_NAME_TOPIC, {parentId, all: true})
}


